import React from "react";
import i18next from "i18next";
import {Web_DocLink} from "../Docflow/Web_DocLink";

export const customization = {
    addGlobalCustomization: (customProps) => {
        const globalFieldExMap = {};

        let result = customProps ? {...customProps} : {};

        result.customFieldExMap = {
            ...globalFieldExMap,
            ...result.customFieldExMap
        };
        return result;
    },
    "EDoc.ListDopDocForPO": {
        customFieldExMap: {
            Web_DocLink: (props) => <Web_DocLink {...props}/>
        }
    }
}